import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { AdminUserRole, AdminUserRolesList } from '@flexyoo/admin/users/models';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-login-multirole',
  templateUrl: 'login-multirole.component.html',
  styleUrls: ['login-multirole.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateModule, MatIconModule, MatButtonModule],
})
export class LoginMultiroleComponent {
  @Input() roles: AdminUserRole[];
  @Input() userName: string;
  @Output() roleSelected = new EventEmitter<AdminUserRole>();

  get sortedRoles() {
    return (this.roles || [])
      .map((m) => m.toLowerCase())
      .sort((a, b) => AdminUserRolesList.indexOf(a as any) - AdminUserRolesList.indexOf(b as any));
  }

  getRoleTranslation(role: AdminUserRole) {
    return `auth.roles.${role.toLowerCase()}`;
  }

  onRoleSelected(role: AdminUserRole) {
    this.roleSelected.next(role);
  }
}
